import { cx } from '../internal/cx';

export interface SkeletonProps {
  /** Quantos blocos desenhar — puramente decorativo/visual. */
  lines?: number;
  variant?: 'text' | 'block' | 'circle';
  width?: string | number;
  height?: string | number;
  className?: string;
  /** Texto anunciado a leitor de tela; nunca fica mudo. */
  label?: string;
}

/**
 * Os blocos visuais são `aria-hidden` (não têm conteúdo semântico nenhum); o
 * anúncio de "carregando" vive uma vez só no container `role="status"`, para não
 * repetir a mesma frase N vezes em leitor de tela quando `lines > 1`.
 */
export function Skeleton({
  lines = 1,
  variant = 'text',
  width,
  height,
  className,
  label = 'Carregando',
}: SkeletonProps) {
  const blocks = Array.from({ length: Math.max(1, lines) });

  return (
    <span className={cx('argink-skeleton-group', className)} role="status">
      <span className="argink-sr-only">{label}</span>
      {blocks.map((_, index) => (
        <span
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          aria-hidden="true"
          className={cx('argink-skeleton', `argink-skeleton--${variant}`, 'argink-motion-safe')}
          style={{ width, height }}
        />
      ))}
    </span>
  );
}
